/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RoleFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PolicyFieldsFragment = { __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string };

export type OperationFieldsFragment = { __typename?: 'OperationModel', operation: string, created_at: string, updated_at: string };

export type PermissionFieldsFragment = { __typename?: 'PermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string };

export type PolicyPermissionFieldsFragment = { __typename?: 'PolicyPermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string, is_enabled: boolean, access_level?: string | null };

export type AdminListRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminListRolesQuery = { __typename?: 'Query', listRoles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }> };

export type AdminGetRoleQueryVariables = Types.Exact<{
  input: Types.GetRoleInput;
}>;


export type AdminGetRoleQuery = { __typename?: 'Query', getRole: { __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string, policies?: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> | null } };

export type AdminListOperationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminListOperationsQuery = { __typename?: 'Query', listOperations: Array<{ __typename?: 'OperationModel', operation: string, created_at: string, updated_at: string }> };

export type AdminGetOperationQueryVariables = Types.Exact<{
  input: Types.GetOperationInput;
}>;


export type AdminGetOperationQuery = { __typename?: 'Query', getOperation: { __typename?: 'OperationModel', operation: string, created_at: string, updated_at: string, policies?: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> | null } };

export type AdminListPoliciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminListPoliciesQuery = { __typename?: 'Query', listPolicies: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> };

export type AdminGetPolicyQueryVariables = Types.Exact<{
  input: Types.GetPolicyInput;
}>;


export type AdminGetPolicyQuery = { __typename?: 'Query', getPolicy: { __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string, permissions?: Array<{ __typename?: 'PolicyPermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string, is_enabled: boolean, access_level?: string | null }> | null } };

export type AdminGetPermissionQueryVariables = Types.Exact<{
  input: Types.GetPermissionInput;
}>;


export type AdminGetPermissionQuery = { __typename?: 'Query', getPermission: { __typename?: 'PermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string } };

export type AdminListPermissionsQueryVariables = Types.Exact<{
  input: Types.ListPermissionsInput;
}>;


export type AdminListPermissionsQuery = { __typename?: 'Query', listPermissions: Array<{ __typename?: 'PermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string }> };

export type AdminAddRoleToUserMutationVariables = Types.Exact<{
  input: Types.UserRoleInput;
}>;


export type AdminAddRoleToUserMutation = { __typename?: 'Mutation', addRoleToUser: { __typename?: 'UserModel', user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }> } };

export type AdminRemoveRoleFromUserMutationVariables = Types.Exact<{
  input: Types.UserRoleInput;
}>;


export type AdminRemoveRoleFromUserMutation = { __typename?: 'Mutation', removeRoleFromUser: { __typename?: 'UserModel', user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }> } };

export type AdminAddPolicyToRoleMutationVariables = Types.Exact<{
  input: Types.RolePolicyInput;
}>;


export type AdminAddPolicyToRoleMutation = { __typename?: 'Mutation', addPolicyToRole: { __typename?: 'RoleModel', role_id: string, policies?: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> | null } };

export type AdminRemovePolicyFromRoleMutationVariables = Types.Exact<{
  input: Types.RolePolicyInput;
}>;


export type AdminRemovePolicyFromRoleMutation = { __typename?: 'Mutation', removePolicyFromRole: { __typename?: 'RoleModel', role_id: string, policies?: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> | null } };

export type AdminAddPolicyToOperationMutationVariables = Types.Exact<{
  input: Types.OperationPolicyInput;
}>;


export type AdminAddPolicyToOperationMutation = { __typename?: 'Mutation', addPolicyToOperation: { __typename?: 'OperationModel', operation: string, created_at: string, updated_at: string, policies?: Array<{ __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string }> | null } };

export type AdminUpdateOperationMutationVariables = Types.Exact<{
  input: Types.UpdateOperationInput;
}>;


export type AdminUpdateOperationMutation = { __typename?: 'Mutation', updateOperation: { __typename?: 'OperationModel', operation: string, created_at: string, updated_at: string } };

export type AdminCreatePolicyMutationVariables = Types.Exact<{
  input: Types.CreatePolicyInput;
}>;


export type AdminCreatePolicyMutation = { __typename?: 'Mutation', createPolicy: { __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string, permissions?: Array<{ __typename?: 'PolicyPermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string, is_enabled: boolean, access_level?: string | null }> | null } };

export type AdminUpdatePolicyMutationVariables = Types.Exact<{
  input: Types.UpdatePolicyInput;
}>;


export type AdminUpdatePolicyMutation = { __typename?: 'Mutation', updatePolicy: { __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string, permissions?: Array<{ __typename?: 'PolicyPermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string, is_enabled: boolean, access_level?: string | null }> | null } };

export type AdminCreateRoleMutationVariables = Types.Exact<{
  input: Types.CreateRoleInput;
}>;


export type AdminCreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string } };

export type AdminUpdateRoleMutationVariables = Types.Exact<{
  input: Types.UpdateRoleInput;
}>;


export type AdminUpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string } };

export type AdminCreatePermissionMutationVariables = Types.Exact<{
  input: Types.CreatePermissionInput;
}>;


export type AdminCreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'PermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string } };

export type AdminUpdatePermissionMutationVariables = Types.Exact<{
  input: Types.UpdatePermissionInput;
}>;


export type AdminUpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'PermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string } };

export type AdminUpdatePolicyPermissionsMutationVariables = Types.Exact<{
  input: Types.SetPolicyPermissionsInput;
}>;


export type AdminUpdatePolicyPermissionsMutation = { __typename?: 'Mutation', updatePolicyPermissions: { __typename?: 'PolicyModel', policy_id: string, policy_name?: string | null, policy_description?: string | null, created_at: string, updated_at: string, permissions?: Array<{ __typename?: 'PolicyPermissionModel', permission_id: string, permission_name: string, permission_scope: string, created_at: string, updated_at: string, is_enabled: boolean, access_level?: string | null }> | null } };

export const PolicyFieldsFragmentDoc = gql`
    fragment PolicyFields on PolicyModel {
  policy_id
  policy_name
  policy_description
  created_at
  updated_at
}
    `;
export const OperationFieldsFragmentDoc = gql`
    fragment OperationFields on OperationModel {
  operation
  created_at
  updated_at
}
    `;
export const PermissionFieldsFragmentDoc = gql`
    fragment PermissionFields on PermissionModel {
  permission_id
  permission_name
  permission_scope
  created_at
  updated_at
}
    `;
export const PolicyPermissionFieldsFragmentDoc = gql`
    fragment PolicyPermissionFields on PolicyPermissionModel {
  permission_id
  permission_name
  permission_scope
  created_at
  updated_at
  is_enabled
  access_level
}
    `;
export const AdminListRolesDocument = gql`
    query adminListRoles {
  listRoles {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export function useAdminListRolesQuery(baseOptions?: Apollo.QueryHookOptions<AdminListRolesQuery, AdminListRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListRolesQuery, AdminListRolesQueryVariables>(AdminListRolesDocument, options);
      }
export function useAdminListRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListRolesQuery, AdminListRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListRolesQuery, AdminListRolesQueryVariables>(AdminListRolesDocument, options);
        }
// @ts-ignore
export function useAdminListRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListRolesQuery, AdminListRolesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListRolesQuery, AdminListRolesQueryVariables>;
export function useAdminListRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListRolesQuery, AdminListRolesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListRolesQuery | undefined, AdminListRolesQueryVariables>;
export function useAdminListRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListRolesQuery, AdminListRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListRolesQuery, AdminListRolesQueryVariables>(AdminListRolesDocument, options);
        }
export type AdminListRolesQueryHookResult = ReturnType<typeof useAdminListRolesQuery>;
export type AdminListRolesLazyQueryHookResult = ReturnType<typeof useAdminListRolesLazyQuery>;
export type AdminListRolesSuspenseQueryHookResult = ReturnType<typeof useAdminListRolesSuspenseQuery>;
export type AdminListRolesQueryResult = Apollo.QueryResult<AdminListRolesQuery, AdminListRolesQueryVariables>;
export const AdminGetRoleDocument = gql`
    query adminGetRole($input: GetRoleInput!) {
  getRole(input: $input) {
    ...RoleFields
    policies {
      ...PolicyFields
    }
  }
}
    ${RoleFieldsFragmentDoc}
${PolicyFieldsFragmentDoc}`;
export function useAdminGetRoleQuery(baseOptions: Apollo.QueryHookOptions<AdminGetRoleQuery, AdminGetRoleQueryVariables> & ({ variables: AdminGetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetRoleQuery, AdminGetRoleQueryVariables>(AdminGetRoleDocument, options);
      }
export function useAdminGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetRoleQuery, AdminGetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetRoleQuery, AdminGetRoleQueryVariables>(AdminGetRoleDocument, options);
        }
// @ts-ignore
export function useAdminGetRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetRoleQuery, AdminGetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetRoleQuery, AdminGetRoleQueryVariables>;
export function useAdminGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetRoleQuery, AdminGetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetRoleQuery | undefined, AdminGetRoleQueryVariables>;
export function useAdminGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetRoleQuery, AdminGetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetRoleQuery, AdminGetRoleQueryVariables>(AdminGetRoleDocument, options);
        }
export type AdminGetRoleQueryHookResult = ReturnType<typeof useAdminGetRoleQuery>;
export type AdminGetRoleLazyQueryHookResult = ReturnType<typeof useAdminGetRoleLazyQuery>;
export type AdminGetRoleSuspenseQueryHookResult = ReturnType<typeof useAdminGetRoleSuspenseQuery>;
export type AdminGetRoleQueryResult = Apollo.QueryResult<AdminGetRoleQuery, AdminGetRoleQueryVariables>;
export const AdminListOperationsDocument = gql`
    query adminListOperations {
  listOperations {
    ...OperationFields
  }
}
    ${OperationFieldsFragmentDoc}`;
export function useAdminListOperationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminListOperationsQuery, AdminListOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListOperationsQuery, AdminListOperationsQueryVariables>(AdminListOperationsDocument, options);
      }
export function useAdminListOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListOperationsQuery, AdminListOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListOperationsQuery, AdminListOperationsQueryVariables>(AdminListOperationsDocument, options);
        }
// @ts-ignore
export function useAdminListOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListOperationsQuery, AdminListOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListOperationsQuery, AdminListOperationsQueryVariables>;
export function useAdminListOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListOperationsQuery, AdminListOperationsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListOperationsQuery | undefined, AdminListOperationsQueryVariables>;
export function useAdminListOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListOperationsQuery, AdminListOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListOperationsQuery, AdminListOperationsQueryVariables>(AdminListOperationsDocument, options);
        }
export type AdminListOperationsQueryHookResult = ReturnType<typeof useAdminListOperationsQuery>;
export type AdminListOperationsLazyQueryHookResult = ReturnType<typeof useAdminListOperationsLazyQuery>;
export type AdminListOperationsSuspenseQueryHookResult = ReturnType<typeof useAdminListOperationsSuspenseQuery>;
export type AdminListOperationsQueryResult = Apollo.QueryResult<AdminListOperationsQuery, AdminListOperationsQueryVariables>;
export const AdminGetOperationDocument = gql`
    query adminGetOperation($input: GetOperationInput!) {
  getOperation(input: $input) {
    ...OperationFields
    policies {
      ...PolicyFields
    }
  }
}
    ${OperationFieldsFragmentDoc}
${PolicyFieldsFragmentDoc}`;
export function useAdminGetOperationQuery(baseOptions: Apollo.QueryHookOptions<AdminGetOperationQuery, AdminGetOperationQueryVariables> & ({ variables: AdminGetOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetOperationQuery, AdminGetOperationQueryVariables>(AdminGetOperationDocument, options);
      }
export function useAdminGetOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetOperationQuery, AdminGetOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetOperationQuery, AdminGetOperationQueryVariables>(AdminGetOperationDocument, options);
        }
// @ts-ignore
export function useAdminGetOperationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetOperationQuery, AdminGetOperationQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetOperationQuery, AdminGetOperationQueryVariables>;
export function useAdminGetOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetOperationQuery, AdminGetOperationQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetOperationQuery | undefined, AdminGetOperationQueryVariables>;
export function useAdminGetOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetOperationQuery, AdminGetOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetOperationQuery, AdminGetOperationQueryVariables>(AdminGetOperationDocument, options);
        }
export type AdminGetOperationQueryHookResult = ReturnType<typeof useAdminGetOperationQuery>;
export type AdminGetOperationLazyQueryHookResult = ReturnType<typeof useAdminGetOperationLazyQuery>;
export type AdminGetOperationSuspenseQueryHookResult = ReturnType<typeof useAdminGetOperationSuspenseQuery>;
export type AdminGetOperationQueryResult = Apollo.QueryResult<AdminGetOperationQuery, AdminGetOperationQueryVariables>;
export const AdminListPoliciesDocument = gql`
    query adminListPolicies {
  listPolicies {
    ...PolicyFields
  }
}
    ${PolicyFieldsFragmentDoc}`;
export function useAdminListPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>(AdminListPoliciesDocument, options);
      }
export function useAdminListPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>(AdminListPoliciesDocument, options);
        }
// @ts-ignore
export function useAdminListPoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>;
export function useAdminListPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListPoliciesQuery | undefined, AdminListPoliciesQueryVariables>;
export function useAdminListPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>(AdminListPoliciesDocument, options);
        }
export type AdminListPoliciesQueryHookResult = ReturnType<typeof useAdminListPoliciesQuery>;
export type AdminListPoliciesLazyQueryHookResult = ReturnType<typeof useAdminListPoliciesLazyQuery>;
export type AdminListPoliciesSuspenseQueryHookResult = ReturnType<typeof useAdminListPoliciesSuspenseQuery>;
export type AdminListPoliciesQueryResult = Apollo.QueryResult<AdminListPoliciesQuery, AdminListPoliciesQueryVariables>;
export const AdminGetPolicyDocument = gql`
    query adminGetPolicy($input: GetPolicyInput!) {
  getPolicy(input: $input) {
    ...PolicyFields
    permissions {
      ...PolicyPermissionFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}
${PolicyPermissionFieldsFragmentDoc}`;
export function useAdminGetPolicyQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPolicyQuery, AdminGetPolicyQueryVariables> & ({ variables: AdminGetPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>(AdminGetPolicyDocument, options);
      }
export function useAdminGetPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>(AdminGetPolicyDocument, options);
        }
// @ts-ignore
export function useAdminGetPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>;
export function useAdminGetPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetPolicyQuery | undefined, AdminGetPolicyQueryVariables>;
export function useAdminGetPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>(AdminGetPolicyDocument, options);
        }
export type AdminGetPolicyQueryHookResult = ReturnType<typeof useAdminGetPolicyQuery>;
export type AdminGetPolicyLazyQueryHookResult = ReturnType<typeof useAdminGetPolicyLazyQuery>;
export type AdminGetPolicySuspenseQueryHookResult = ReturnType<typeof useAdminGetPolicySuspenseQuery>;
export type AdminGetPolicyQueryResult = Apollo.QueryResult<AdminGetPolicyQuery, AdminGetPolicyQueryVariables>;
export const AdminGetPermissionDocument = gql`
    query adminGetPermission($input: GetPermissionInput!) {
  getPermission(input: $input) {
    ...PermissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export function useAdminGetPermissionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPermissionQuery, AdminGetPermissionQueryVariables> & ({ variables: AdminGetPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>(AdminGetPermissionDocument, options);
      }
export function useAdminGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>(AdminGetPermissionDocument, options);
        }
// @ts-ignore
export function useAdminGetPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>;
export function useAdminGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<AdminGetPermissionQuery | undefined, AdminGetPermissionQueryVariables>;
export function useAdminGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>(AdminGetPermissionDocument, options);
        }
export type AdminGetPermissionQueryHookResult = ReturnType<typeof useAdminGetPermissionQuery>;
export type AdminGetPermissionLazyQueryHookResult = ReturnType<typeof useAdminGetPermissionLazyQuery>;
export type AdminGetPermissionSuspenseQueryHookResult = ReturnType<typeof useAdminGetPermissionSuspenseQuery>;
export type AdminGetPermissionQueryResult = Apollo.QueryResult<AdminGetPermissionQuery, AdminGetPermissionQueryVariables>;
export const AdminListPermissionsDocument = gql`
    query adminListPermissions($input: ListPermissionsInput!) {
  listPermissions(input: $input) {
    ...PermissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export function useAdminListPermissionsQuery(baseOptions: Apollo.QueryHookOptions<AdminListPermissionsQuery, AdminListPermissionsQueryVariables> & ({ variables: AdminListPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>(AdminListPermissionsDocument, options);
      }
export function useAdminListPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>(AdminListPermissionsDocument, options);
        }
// @ts-ignore
export function useAdminListPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>;
export function useAdminListPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminListPermissionsQuery | undefined, AdminListPermissionsQueryVariables>;
export function useAdminListPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>(AdminListPermissionsDocument, options);
        }
export type AdminListPermissionsQueryHookResult = ReturnType<typeof useAdminListPermissionsQuery>;
export type AdminListPermissionsLazyQueryHookResult = ReturnType<typeof useAdminListPermissionsLazyQuery>;
export type AdminListPermissionsSuspenseQueryHookResult = ReturnType<typeof useAdminListPermissionsSuspenseQuery>;
export type AdminListPermissionsQueryResult = Apollo.QueryResult<AdminListPermissionsQuery, AdminListPermissionsQueryVariables>;
export const AdminAddRoleToUserDocument = gql`
    mutation adminAddRoleToUser($input: UserRoleInput!) {
  addRoleToUser(input: $input) {
    user_id
    roles {
      ...RoleFields
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export type AdminAddRoleToUserMutationFn = Apollo.MutationFunction<AdminAddRoleToUserMutation, AdminAddRoleToUserMutationVariables>;
export function useAdminAddRoleToUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddRoleToUserMutation, AdminAddRoleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddRoleToUserMutation, AdminAddRoleToUserMutationVariables>(AdminAddRoleToUserDocument, options);
      }
export type AdminAddRoleToUserMutationHookResult = ReturnType<typeof useAdminAddRoleToUserMutation>;
export type AdminAddRoleToUserMutationResult = Apollo.MutationResult<AdminAddRoleToUserMutation>;
export type AdminAddRoleToUserMutationOptions = Apollo.BaseMutationOptions<AdminAddRoleToUserMutation, AdminAddRoleToUserMutationVariables>;
export const AdminRemoveRoleFromUserDocument = gql`
    mutation adminRemoveRoleFromUser($input: UserRoleInput!) {
  removeRoleFromUser(input: $input) {
    user_id
    roles {
      ...RoleFields
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export type AdminRemoveRoleFromUserMutationFn = Apollo.MutationFunction<AdminRemoveRoleFromUserMutation, AdminRemoveRoleFromUserMutationVariables>;
export function useAdminRemoveRoleFromUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminRemoveRoleFromUserMutation, AdminRemoveRoleFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRemoveRoleFromUserMutation, AdminRemoveRoleFromUserMutationVariables>(AdminRemoveRoleFromUserDocument, options);
      }
export type AdminRemoveRoleFromUserMutationHookResult = ReturnType<typeof useAdminRemoveRoleFromUserMutation>;
export type AdminRemoveRoleFromUserMutationResult = Apollo.MutationResult<AdminRemoveRoleFromUserMutation>;
export type AdminRemoveRoleFromUserMutationOptions = Apollo.BaseMutationOptions<AdminRemoveRoleFromUserMutation, AdminRemoveRoleFromUserMutationVariables>;
export const AdminAddPolicyToRoleDocument = gql`
    mutation adminAddPolicyToRole($input: RolePolicyInput!) {
  addPolicyToRole(input: $input) {
    role_id
    policies {
      ...PolicyFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}`;
export type AdminAddPolicyToRoleMutationFn = Apollo.MutationFunction<AdminAddPolicyToRoleMutation, AdminAddPolicyToRoleMutationVariables>;
export function useAdminAddPolicyToRoleMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddPolicyToRoleMutation, AdminAddPolicyToRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddPolicyToRoleMutation, AdminAddPolicyToRoleMutationVariables>(AdminAddPolicyToRoleDocument, options);
      }
export type AdminAddPolicyToRoleMutationHookResult = ReturnType<typeof useAdminAddPolicyToRoleMutation>;
export type AdminAddPolicyToRoleMutationResult = Apollo.MutationResult<AdminAddPolicyToRoleMutation>;
export type AdminAddPolicyToRoleMutationOptions = Apollo.BaseMutationOptions<AdminAddPolicyToRoleMutation, AdminAddPolicyToRoleMutationVariables>;
export const AdminRemovePolicyFromRoleDocument = gql`
    mutation adminRemovePolicyFromRole($input: RolePolicyInput!) {
  removePolicyFromRole(input: $input) {
    role_id
    policies {
      ...PolicyFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}`;
export type AdminRemovePolicyFromRoleMutationFn = Apollo.MutationFunction<AdminRemovePolicyFromRoleMutation, AdminRemovePolicyFromRoleMutationVariables>;
export function useAdminRemovePolicyFromRoleMutation(baseOptions?: Apollo.MutationHookOptions<AdminRemovePolicyFromRoleMutation, AdminRemovePolicyFromRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRemovePolicyFromRoleMutation, AdminRemovePolicyFromRoleMutationVariables>(AdminRemovePolicyFromRoleDocument, options);
      }
export type AdminRemovePolicyFromRoleMutationHookResult = ReturnType<typeof useAdminRemovePolicyFromRoleMutation>;
export type AdminRemovePolicyFromRoleMutationResult = Apollo.MutationResult<AdminRemovePolicyFromRoleMutation>;
export type AdminRemovePolicyFromRoleMutationOptions = Apollo.BaseMutationOptions<AdminRemovePolicyFromRoleMutation, AdminRemovePolicyFromRoleMutationVariables>;
export const AdminAddPolicyToOperationDocument = gql`
    mutation adminAddPolicyToOperation($input: OperationPolicyInput!) {
  addPolicyToOperation(input: $input) {
    ...OperationFields
    policies {
      ...PolicyFields
    }
  }
}
    ${OperationFieldsFragmentDoc}
${PolicyFieldsFragmentDoc}`;
export type AdminAddPolicyToOperationMutationFn = Apollo.MutationFunction<AdminAddPolicyToOperationMutation, AdminAddPolicyToOperationMutationVariables>;
export function useAdminAddPolicyToOperationMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddPolicyToOperationMutation, AdminAddPolicyToOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddPolicyToOperationMutation, AdminAddPolicyToOperationMutationVariables>(AdminAddPolicyToOperationDocument, options);
      }
export type AdminAddPolicyToOperationMutationHookResult = ReturnType<typeof useAdminAddPolicyToOperationMutation>;
export type AdminAddPolicyToOperationMutationResult = Apollo.MutationResult<AdminAddPolicyToOperationMutation>;
export type AdminAddPolicyToOperationMutationOptions = Apollo.BaseMutationOptions<AdminAddPolicyToOperationMutation, AdminAddPolicyToOperationMutationVariables>;
export const AdminUpdateOperationDocument = gql`
    mutation adminUpdateOperation($input: UpdateOperationInput!) {
  updateOperation(input: $input) {
    ...OperationFields
  }
}
    ${OperationFieldsFragmentDoc}`;
export type AdminUpdateOperationMutationFn = Apollo.MutationFunction<AdminUpdateOperationMutation, AdminUpdateOperationMutationVariables>;
export function useAdminUpdateOperationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOperationMutation, AdminUpdateOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOperationMutation, AdminUpdateOperationMutationVariables>(AdminUpdateOperationDocument, options);
      }
export type AdminUpdateOperationMutationHookResult = ReturnType<typeof useAdminUpdateOperationMutation>;
export type AdminUpdateOperationMutationResult = Apollo.MutationResult<AdminUpdateOperationMutation>;
export type AdminUpdateOperationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOperationMutation, AdminUpdateOperationMutationVariables>;
export const AdminCreatePolicyDocument = gql`
    mutation adminCreatePolicy($input: CreatePolicyInput!) {
  createPolicy(input: $input) {
    ...PolicyFields
    permissions {
      ...PolicyPermissionFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}
${PolicyPermissionFieldsFragmentDoc}`;
export type AdminCreatePolicyMutationFn = Apollo.MutationFunction<AdminCreatePolicyMutation, AdminCreatePolicyMutationVariables>;
export function useAdminCreatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePolicyMutation, AdminCreatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePolicyMutation, AdminCreatePolicyMutationVariables>(AdminCreatePolicyDocument, options);
      }
export type AdminCreatePolicyMutationHookResult = ReturnType<typeof useAdminCreatePolicyMutation>;
export type AdminCreatePolicyMutationResult = Apollo.MutationResult<AdminCreatePolicyMutation>;
export type AdminCreatePolicyMutationOptions = Apollo.BaseMutationOptions<AdminCreatePolicyMutation, AdminCreatePolicyMutationVariables>;
export const AdminUpdatePolicyDocument = gql`
    mutation adminUpdatePolicy($input: UpdatePolicyInput!) {
  updatePolicy(input: $input) {
    ...PolicyFields
    permissions {
      ...PolicyPermissionFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}
${PolicyPermissionFieldsFragmentDoc}`;
export type AdminUpdatePolicyMutationFn = Apollo.MutationFunction<AdminUpdatePolicyMutation, AdminUpdatePolicyMutationVariables>;
export function useAdminUpdatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePolicyMutation, AdminUpdatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePolicyMutation, AdminUpdatePolicyMutationVariables>(AdminUpdatePolicyDocument, options);
      }
export type AdminUpdatePolicyMutationHookResult = ReturnType<typeof useAdminUpdatePolicyMutation>;
export type AdminUpdatePolicyMutationResult = Apollo.MutationResult<AdminUpdatePolicyMutation>;
export type AdminUpdatePolicyMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePolicyMutation, AdminUpdatePolicyMutationVariables>;
export const AdminCreateRoleDocument = gql`
    mutation adminCreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type AdminCreateRoleMutationFn = Apollo.MutationFunction<AdminCreateRoleMutation, AdminCreateRoleMutationVariables>;
export function useAdminCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateRoleMutation, AdminCreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateRoleMutation, AdminCreateRoleMutationVariables>(AdminCreateRoleDocument, options);
      }
export type AdminCreateRoleMutationHookResult = ReturnType<typeof useAdminCreateRoleMutation>;
export type AdminCreateRoleMutationResult = Apollo.MutationResult<AdminCreateRoleMutation>;
export type AdminCreateRoleMutationOptions = Apollo.BaseMutationOptions<AdminCreateRoleMutation, AdminCreateRoleMutationVariables>;
export const AdminUpdateRoleDocument = gql`
    mutation adminUpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type AdminUpdateRoleMutationFn = Apollo.MutationFunction<AdminUpdateRoleMutation, AdminUpdateRoleMutationVariables>;
export function useAdminUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateRoleMutation, AdminUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateRoleMutation, AdminUpdateRoleMutationVariables>(AdminUpdateRoleDocument, options);
      }
export type AdminUpdateRoleMutationHookResult = ReturnType<typeof useAdminUpdateRoleMutation>;
export type AdminUpdateRoleMutationResult = Apollo.MutationResult<AdminUpdateRoleMutation>;
export type AdminUpdateRoleMutationOptions = Apollo.BaseMutationOptions<AdminUpdateRoleMutation, AdminUpdateRoleMutationVariables>;
export const AdminCreatePermissionDocument = gql`
    mutation adminCreatePermission($input: CreatePermissionInput!) {
  createPermission(input: $input) {
    ...PermissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type AdminCreatePermissionMutationFn = Apollo.MutationFunction<AdminCreatePermissionMutation, AdminCreatePermissionMutationVariables>;
export function useAdminCreatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePermissionMutation, AdminCreatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePermissionMutation, AdminCreatePermissionMutationVariables>(AdminCreatePermissionDocument, options);
      }
export type AdminCreatePermissionMutationHookResult = ReturnType<typeof useAdminCreatePermissionMutation>;
export type AdminCreatePermissionMutationResult = Apollo.MutationResult<AdminCreatePermissionMutation>;
export type AdminCreatePermissionMutationOptions = Apollo.BaseMutationOptions<AdminCreatePermissionMutation, AdminCreatePermissionMutationVariables>;
export const AdminUpdatePermissionDocument = gql`
    mutation adminUpdatePermission($input: UpdatePermissionInput!) {
  updatePermission(input: $input) {
    ...PermissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type AdminUpdatePermissionMutationFn = Apollo.MutationFunction<AdminUpdatePermissionMutation, AdminUpdatePermissionMutationVariables>;
export function useAdminUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePermissionMutation, AdminUpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePermissionMutation, AdminUpdatePermissionMutationVariables>(AdminUpdatePermissionDocument, options);
      }
export type AdminUpdatePermissionMutationHookResult = ReturnType<typeof useAdminUpdatePermissionMutation>;
export type AdminUpdatePermissionMutationResult = Apollo.MutationResult<AdminUpdatePermissionMutation>;
export type AdminUpdatePermissionMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePermissionMutation, AdminUpdatePermissionMutationVariables>;
export const AdminUpdatePolicyPermissionsDocument = gql`
    mutation adminUpdatePolicyPermissions($input: SetPolicyPermissionsInput!) {
  updatePolicyPermissions(input: $input) {
    ...PolicyFields
    permissions {
      ...PolicyPermissionFields
    }
  }
}
    ${PolicyFieldsFragmentDoc}
${PolicyPermissionFieldsFragmentDoc}`;
export type AdminUpdatePolicyPermissionsMutationFn = Apollo.MutationFunction<AdminUpdatePolicyPermissionsMutation, AdminUpdatePolicyPermissionsMutationVariables>;
export function useAdminUpdatePolicyPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePolicyPermissionsMutation, AdminUpdatePolicyPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePolicyPermissionsMutation, AdminUpdatePolicyPermissionsMutationVariables>(AdminUpdatePolicyPermissionsDocument, options);
      }
export type AdminUpdatePolicyPermissionsMutationHookResult = ReturnType<typeof useAdminUpdatePolicyPermissionsMutation>;
export type AdminUpdatePolicyPermissionsMutationResult = Apollo.MutationResult<AdminUpdatePolicyPermissionsMutation>;
export type AdminUpdatePolicyPermissionsMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePolicyPermissionsMutation, AdminUpdatePolicyPermissionsMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useAdminListRoles = withQueryResponseHandler(useAdminListRolesQuery);
export const useAdminGetRole = withQueryResponseHandler(useAdminGetRoleQuery);
export const useAdminListOperations = withQueryResponseHandler(useAdminListOperationsQuery);
export const useAdminGetOperation = withQueryResponseHandler(useAdminGetOperationQuery);
export const useAdminListPolicies = withQueryResponseHandler(useAdminListPoliciesQuery);
export const useAdminGetPolicy = withQueryResponseHandler(useAdminGetPolicyQuery);
export const useAdminGetPermission = withQueryResponseHandler(useAdminGetPermissionQuery);
export const useAdminListPermissions = withQueryResponseHandler(useAdminListPermissionsQuery);
export const useAdminAddRoleToUser = withMutationResponseHandler(useAdminAddRoleToUserMutation, "adminAddRoleToUser");
export const useAdminRemoveRoleFromUser = withMutationResponseHandler(useAdminRemoveRoleFromUserMutation, "adminRemoveRoleFromUser");
export const useAdminAddPolicyToRole = withMutationResponseHandler(useAdminAddPolicyToRoleMutation, "adminAddPolicyToRole");
export const useAdminRemovePolicyFromRole = withMutationResponseHandler(useAdminRemovePolicyFromRoleMutation, "adminRemovePolicyFromRole");
export const useAdminAddPolicyToOperation = withMutationResponseHandler(useAdminAddPolicyToOperationMutation, "adminAddPolicyToOperation");
export const useAdminUpdateOperation = withMutationResponseHandler(useAdminUpdateOperationMutation, "adminUpdateOperation");
export const useAdminCreatePolicy = withMutationResponseHandler(useAdminCreatePolicyMutation, "adminCreatePolicy");
export const useAdminUpdatePolicy = withMutationResponseHandler(useAdminUpdatePolicyMutation, "adminUpdatePolicy");
export const useAdminCreateRole = withMutationResponseHandler(useAdminCreateRoleMutation, "adminCreateRole");
export const useAdminUpdateRole = withMutationResponseHandler(useAdminUpdateRoleMutation, "adminUpdateRole");
export const useAdminCreatePermission = withMutationResponseHandler(useAdminCreatePermissionMutation, "adminCreatePermission");
export const useAdminUpdatePermission = withMutationResponseHandler(useAdminUpdatePermissionMutation, "adminUpdatePermission");
export const useAdminUpdatePolicyPermissions = withMutationResponseHandler(useAdminUpdatePolicyPermissionsMutation, "adminUpdatePolicyPermissions");